<template>
  <v-layout lp-header>
    <picture>
      <source
        srcset="/img/programs/fellowship/mayo/lpFellowshipLogoMayoPC.webp"
        type="image/webp"
      />
      <source srcset="/img/programs/fellowship/mayo/lpFellowshipLogoMayoPC.png" type="image/png" />
      <img
        src="/img/programs/fellowship/mayo/lpFellowshipLogoMayoPC.png"
        alt="[Logo]"
        class="logo-img d-none d-md-inline"
      />
    </picture>
    <picture>
      <source
        srcset="/img/programs/fellowship/mayo/lpFellowshipLogoMayoSP.webp"
        type="image/webp"
      />
      <source srcset="/img/programs/fellowship/mayo/lpFellowshipLogoMayoSP.png" type="image/png" />
      <img
        src="/img/programs/fellowship/mayo/lpFellowshipLogoMayoSP.png"
        alt="[Logo]"
        class="logo-img d-inline d-md-none"
      />
    </picture>
    <v-spacer></v-spacer>
    <div v-show="!hideDownloads" class="install-wrapper">
      <button
        class="btn-install btn-shrink"
        @click="$vuetify.goTo('#apply-form', { duration: 500, easing: 'easeInOutCubic' })"
      >
        <div class="text-btn">Apply Here</div>
      </button>
    </div>
  </v-layout>
</template>

<script>
export default {
  props: { hideDownloads: { type: Boolean, default: () => false } },
};
</script>

<style scoped>
.lp-header {
  position: fixed;
  z-index: 3;
  top: 0;
  width: 100vw;
  height: 50px;
  background-color: white;
  box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.5);
}
.logo-img {
  width: 235px;
  height: 32px;
  margin-top: 10px;
  margin-left: 15px;
}
.install-wrapper {
  height: 116px;
  width: 440px;
  text-align: right;
  padding-top: 16px;
  padding-right: 12px;
  background-image: url('/img/programs/fellowship/mayo/lpFrmHeaderAccent.png');
  background-size: cover;
  background-position: left bottom;
}
.webp .install-wrapper {
  background-image: url('/img/programs/fellowship/mayo/lpFrmHeaderAccent.webp');
}
.btn-install {
  width: 315px;
  height: 70px;
  outline: none;
  color: #fff;
  text-align: center;
  background-image: url('/img/lp/lpBtnConversionSmallNomal.png');
  background-size: cover;
  padding-bottom: 2px;
}
.btn-install:hover {
  background-image: url('/img/lp/lpBtnConversionSmallHover.png');
}
.text-btn-sm {
  font-weight: bold;
  font-size: 16px;
  line-height: 1em;
  margin-top: 2px;
}
.text-btn {
  font-weight: bold;
  font-size: 30px;
}
.install-wrapper.app-install {
  width: 550px;
  height: 134px;
  padding: 24px 20px 0 0;
}
@media (max-width: 959px) {
  .lp-header {
    height: 50px;
  }
  .logo-img {
    width: 102px;
    height: 32px;
  }
}
@media (max-width: 767px) {
  .install-wrapper {
    height: 75px;
    width: 254px;
    padding-top: 8px;
    padding-right: 8px;
  }
  .install-wrapper.app-install {
    height: 50px;
    width: 240px;
    padding: 6px 8px 0 0;
  }
  .btn-install {
    width: 198px;
    height: 44px;
  }
  .text-btn-sm {
    font-size: 10px;
  }
  .text-btn {
    font-size: 18px;
  }
}
@media (max-width: 360px) {
  .btn-install {
    width: 150px;
    height: 33px;
  }
}
</style>
